import { Component, OnInit } from '@angular/core';

import {AppBaseComponent} from "@utils";
import {MessageService, ProcedureService,TrackingService,DocumentService} from "@services";


@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.scss']
})
export class UserDashboardComponent extends AppBaseComponent implements OnInit {

  allByUser: any[] = [];

  step: number = 4;

  currentStep: number = 100

  datalocalURL: string;

  showFormByUser: boolean = false;

  tramiteSeleccionado: any;

  trackingTramiteActual: any;

  constructor(private procedureService: ProcedureService,
              private popUpService: MessageService,
              private trackingService: TrackingService,
              private documentService: DocumentService) {
    super();
  }

  ngOnInit(): void {
    this.getAllByUser();

  }

  /*
  sortInfoDesc() {
    this.allByUser.sort((a, b) => 0 - (a > b ? -1 : 1));
  }
  */

  getAllByUser(){
    this.procedureService.getAllByUser()
      .subscribe(resp => {
        console.log(resp);
        this.allByUser = resp;
      })
  }

  isValidation(status: string): boolean {
    let validation = false;

    if (status != 'Solicitar más información' && status != 'Firma Aprobación' && status != 'Firma Negación' && status != 'Licencia Revocada' ) {
      validation = true;
    }

    return validation;
  }

  showLicencia(idLicencia): void {

    try {
      this.popUpService.infoAlert(
        'Cargando documento licencia...',
        4000);

      let fileObtenido = null;
      // tslint:disable-next-line: no-unused-variable
      this.documentService.getViewPdfById(idLicencia).subscribe((values) => {
        console.log("valor documento", values)
        fileObtenido = values.content;
        const byteArray = new Uint8Array(atob(fileObtenido).split('').map((char) => char.charCodeAt(0)));
        const file = new Blob([byteArray], {type: 'application/pdf'});
        this.datalocalURL = URL.createObjectURL(file);
        window.open(this.datalocalURL, '_blank');
      }, error => {
        this.popUpService.errorAlert(
          'Ocurrió un error al cargar el documento.',
          4000);
      })
    } catch (e) {
      this.popUpService.errorAlert(
        'Ocurrió un error al cargar el documento.',
        4000);
    }

  }

  getTramiteActual(id): void {

    this.popUpService.infoAlert('Cargando tramite...', 4000);

    this.procedureService.getById(id).subscribe((resp) => {
      this.tramiteSeleccionado = resp;
      this.showFormByUser = true;
      console.log('estoy en tramite seleccionado');
      console.log(this.tramiteSeleccionado);
      this.trackingService.getInfoSeguimiento(this.tramiteSeleccionado.id).subscribe((resp) => {
        this.trackingTramiteActual = resp[resp.length - 1];
        console.log("estoy en tracking", this.trackingTramiteActual)
      })
    });



  }

  public cancelFrm() {
    this.showFormByUser = false;
  }

}
